<template>
  <div
    style="width: 16px;
    height: 16px;
    cursor: pointer;
    margin-right: 8px;"
          :class="messageIconClass"
          @click="handleIconClick" title="重新发送"
  >{{messageIconClass==='message-send-fail'? '!':''}}
    <span v-if="messageIconClass!=='message-send-fail' && messageIconClass != 'icon iconfont iconloading'" :class="[message.isReaded?'iconyidu':'iconweidu','icon iconfont']"></span>
  </div>
</template>

<script>
  import {mapState} from 'vuex'
export default {
  name: 'MessageStatusIcon',
  props: {
    message: {
      type: Object,
      required: true
    }
  },
  computed: {
    messageIconClass() {
      switch (this.message.state) {
        case this.TYPES.MSG_STATE.SENDING:
          return 'icon iconfont iconloading'
        case this.TYPES.MSG_STATE.SENT_FAIL:
          return 'message-send-fail'
        default:
          return ''
      }
    },
    ...mapState({
      memberList: state => state.group.currentMemberList,
      userID: state => state.user.userID,
      toAccount: state => state.conversation.toAccount,
      currentConversationType: state => state.conversation.currentConversationType,
      sign: state => state.conversation.sign,
      APPID: state => state.conversation.APPID,
      platform: state => state.conversation.platform,
      isNeedAssignCustomer: state => state.conversation.isNeedAssignCustomer,
      color:state => state.user.color,
      enterid:state => state.user.enterid,
      nickname:state => state.user.nickname,
      headimgurl:state => state.user.headimgurl,
      anonymity:state => state.user.anonymity,
    })
  },
  methods: {
    handleIconClick() {
      if (this.messageIconClass === 'message-send-fail') {
        let re_message = this.tim.createCustomMessage({
          to: this.toAccount,
          conversationType: this.currentConversationType,
          payload: {
            data: JSON.stringify({
              sign: this.sign,
              appid: this.APPID,
              platform: this.platform,
              nickname: this.nickname,
              headimgurl: this.headimgurl,
              content: this.message.content,
              bizmsgmenuid: '',
              session_id: ''
            }),
            extension: this.message.type
          }
        })
        this.$store.commit('removeMessage', this.message)
        let localMessage = this.pushLocalMessage(this.message.content, this.message.type)
        this.tim.resendMessage(re_message).then(res => {
          localMessage.state = this.TYPES.MSG_STATE.SENT_SUCCESS
          localMessage.msg_id = res.data.message.ID
          localMessage.conversationID = res.data.message.conversationID
          localMessage.conversationType = res.data.message.conversationType
          localMessage.isReaded = res.data.message.conversationType == 'GROUP'
          this.message.state = this.TYPES.MSG_STATE.SENT_SUCCESS
          // eslint-disable-next-line no-unused-vars
        }).catch(imError => {
          localMessage.state = this.TYPES.MSG_STATE.SENT_FAIL
        })
      }
    },
    /**
     * 添加本地消息记录
     * @param {string} content 消息内容
     * @param {string} msgType 消息类型
     */
    pushLocalMessage(content, msgType) {
      let createTime = new Date().getTime()
      let localMessage = {
        nickname: this.nickname,
        sendFrom: this.TYPES.MSG_FROM.USER,
        state: this.TYPES.MSG_STATE.SENDING,
        headimgurl: this.headimgurl,
        createTime: createTime,
        content: content,
        type: msgType,
        isReaded: false
      }
      this.$store.dispatch('formatSendTime', localMessage)
      this.$store.commit('pushCurrentMessageList', localMessage)
      this.$bus.$emit('scroll-bottom')
      return localMessage
    }
  }
}
</script>

<style lang="stylus" scoped>
.message-send-fail {
  margin-right: 8px;
  background-color: #f35f5f;
  color: $white;
  border-radius: 50%;
  text-align: center;
  line-height: 16px;
  // cursor: pointer;
}
.el-dropdown-selfdefine {
  outline: none;
}
</style>
